<template>
    <div>
        <div class="active-list">
            <template v-if="isload">
                <div class="active-item " :class="item.status == 2 ? 'active-end' : ''"
                    v-for="(item, index) in activeList" :key="index" @click="goActive(item)">
                    <div class="name">
                        <!-- 0 问卷 1随堂测验 2讨论 -->
                        <div class="tag" v-if="item.type == 0">问卷</div>
                        <div class="tag tagstyle2" v-if="item.type == 1">随堂练习</div>
                        <div class="tag tagstyle3" v-if="item.type == 2">讨论</div>
                        <span>{{ item.title }}</span>
                    </div>
                    <div class="deta" :class="item.isJoin == 1 ? 'datastyle1' : 'datastyle2'" v-if="item.status == 1">
                        <!-- status 0未开始  1进行中  2已结束 -->
                        <img v-if="item.isJoin == 1" src="../../../../assets/icon/deta_active.png" alt="">
                        <img v-else src="../../../../assets/icon/deta_active2.png" alt="">
                        <span>{{ parseTime(item.startTime, '{m}-{d} {h}:{i}') }} 至
                            {{ parseTime(item.endTime, '{m}-{d} {h}:{i}') }}</span>
                    </div>
                    <div class="deta " v-if="item.status == 0">
                        <img src="../../../../assets/icon/deta.png" alt="">
                        <span style="color: #666;">未开始</span>
                    </div>
                    <div class="deta" v-if="item.status == 2">
                        <img src="../../../../assets/icon/deta.png" alt="">
                        <span>已结束</span>
                    </div>
                </div>
            </template>

            <noData v-if="total == 0"></noData>

        </div>
        <div class="pagination-box" style="margin-left: 20px;margin-top: 20px;">
            <el-pagination class="ou-pagination" background hide-on-single-page @size-change="changePageSize"
                @current-change="changePageCurrent" :current-page="pageNum" :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper, slot" :total="total">
                <el-button @click="getCurrentTabList" class="ou-page-go">GO</el-button>
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { GetActiveList } from '@/api/user/course'
import noData from "@/components/noData.vue";
export default {
    name: 'ClassActivities',
    components: { noData },
    props: {
        courseData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            activeList: [],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            isload: false,
        }
    },
    watch: {
        courseData: {
            handler() {
                this.getlist()
            }
        },
    },
    mounted() {
        this.getlist()
    },
    methods: {
        getlist() {
            this.isload = false
            GetActiveList({
                classId: this.courseData.classId,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            }).then(res => {
                this.activeList = res.rows
                this.total = res.total
                this.isload = true
            })
        },
        //切换页尺寸
        changePageSize(val) {
            this.pageSize = val;
            this.getCurrentTabList()
        },
        changePageCurrent(val) {
            this.pageNum = val;
            this.getCurrentTabList()

        },
        getCurrentTabList() {
            this.getlist()
        },
        goActive(item) {

            console.log(item)
            if (item.status == 0) {
                this.$message({
                    type: "warning",
                    message: "活动未开始!",
                    duration: 1500,
                });
                return
            }
            if (item.status == 2 && item.isJoin == 0) {
                this.$message({
                    type: "warning",
                    message: "活动已结束!",
                    duration: 1500,
                });
                return
            }

            if (item.type == 2) {
                this.$router.push({
                    path: "/course/discussion",
                    query: {
                        activityId: item.id,
                        goodsId: this.courseData.goodsId,
                        courseDetail: JSON.stringify(this.courseData)
                    },
                });
            } else {
                if (item.isJoin == 1) {
                    const hrefs = this.$router.resolve({
                        path: "/bookstore/classDetails",
                        query: {
                            paperId: item.paperId,
                            activityId: item.id,
                            activityType: item.type,
                        },
                    });
                    window.open(hrefs.href, '_blank')
                    return
                }
                if (item.isJoin == 0) {
                    const hrefs = this.$router.resolve({
                        path: "/bookstore/practiceClass",
                        query: {
                            paperId: item.paperId,
                            activityId: item.id,
                            activityType: item.type,
                        },
                    });
                    window.open(hrefs.href, '_blank')
                }

            }
        }
    }
}
</script>
<style scoped lang='scss'>
.pagination-box {
    text-align: center;
    margin: 20px 0;
}

.active-list {
    padding: 0 20px;
    min-height: 550px;

    .active-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 12px;
        border-bottom: 1px solid #F3F2F0;
        margin-bottom: 12px;

        .name {
            display: flex;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            cursor: pointer;
            max-width: 80%;

            .tag {
                min-width: 72px;
                width: 72px;
                height: 30px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 2px solid #0081CE;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #0081CE;
                text-align: center;
                line-height: 29px;
                margin-right: 20px;
            }

            .tagstyle2 {
                border-color: #F17F53;
                color: #F17F53;
            }

            .tagstyle3 {
                border-color: #979797;
                color: #979797;
            }

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            span:hover {
                color: #0081CE;
            }
        }

        .deta {
            display: flex;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #48A86C;


            img {
                width: 16px;
                height: 16px;
                margin-right: 6px;
            }
        }

        .datastyle1 {
            color: #48A86C;
        }

        .datastyle2 {
            color: #F17F53;
        }
    }

    .active-end {
        .name {
            color: #999999 !important;
        }

        .deta {
            color: #999999 !important;
        }
    }
}
</style>